export class ArrayUtils
{
	// Creates a new array which doesn't contain the same element twice
	// Note that it doesn't modify the original array
	// https://stackoverflow.com/questions/9229645/remove-duplicate-values-from-js-array
	public static removeDuplicates<T>(array: T[])
	{
		return [...new Set(array)];
	}
}